/**
 * @fileoverview Error thrown by the Generation API key client when the API refuses or fails a request.
 */

/**
 * An answer the API refused or failed, with the status so a caller can tell a refusal it should stop on (403: not
 * a role that may read this) from a failure it may read again. The message is the backend's own copy when it sent
 * one (`fromBackend`), and the client's operator fallback otherwise; only the first may reach a screen
 * (isPlumbingError).
 */
export class GenerationApiRequestError extends Error {
  readonly status: number
  readonly fromBackend: boolean

  constructor(message: string, status: number, fromBackend: boolean) {
    super(message)
    this.name = 'GenerationApiRequestError'
    this.status = status
    this.fromBackend = fromBackend
  }
}

/** A Generation API refusal whose message is the client's own fallback, not the backend's copy. */
export function isLocalGenerationApiRequestError(err: unknown): err is GenerationApiRequestError {
  return err instanceof GenerationApiRequestError && !err.fromBackend
}
